import axios from "axios";
let link = "https://acadshr.sulonya.com";
const instituteLink = "https://acadshr.herokuapp.com";

export const getAllSpecialization = () => {
  return axios.get(`${link}/admin/course/specialization`);
};

export const getAllColleges = () => {
  return axios.get(`${link}/admin/college`);
};

export const getAllUniversities = () => {
  return axios.get(`${link}/admin/university`);
};

export const getAllCourses = () => {
  return axios.get(`${link}/admin/course`);
};
export const getAllInstituteJobs = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "get",
    url: `${link}/ahr/job`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
export const getInstituteJobDetailsById = (id) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "get",
    url: `${link}/ahr/job/${id}`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

export const getProfileDetails = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "get",
    url: `${link}/ahr/candidate/profile`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
export const getInstituteProfile = () => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "get",
    url: `${link}/ahr/institute/profile`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

export const getInstituteContacts = () => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "post",
    url: `${link}/ahr/institute/contact `,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

export const getAllJobs = (data) => {
  let temp = JSON.stringify({ ...data });
  console.log("job data", temp);
  let config = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    url: `${link}/candidate/jobs/allJobs`,
    data: temp,
  };
  return axios(config);
};
export const getJobDetails = (id) => {
  return axios.get(`${link}/candidate/jobs/viewJobDetail/${id}`);
};
export const getSavedJobsId = (data) => {
  let token = localStorage.getItem("userToken");
  let temp = JSON.stringify({ ...data });
  let config = {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${link}/candidate/jobs/savedJobsArray`,
    data: temp,
  };
  return axios(config);
};

export const getAppliedJobs = (id) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "post",
    url: `${link}/candidate/jobs/assigned/${id}`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      jobTitle: "",
      city: "",
      country: "",
      jobCategory: "",
      custField4: "",
      jobDescription: "",
      start: "1",
      numOfRecords: "9",
      websitePublish: "",
    },
  };
  return axios(config);
};
export const getAllFAQ = () => {
  return axios.get(`${link}/admin/product_management/faq`);
};
export const getAllTestimonials = () => {
  return axios.get(`${link}/admin/product_management/testimonials`);
};
export const getTermsAndConditions = () => {
  return axios.get(`${link}/admin/product_management/terms_and_conditions`);
};

export const getPrivacyPolicy = () => {
  return axios.get(`${link}/admin/product_management/privacy_policy`);
};
export const getJobCount = () => {
  return axios.get(`${link}/candidate/jobs/totalJobsCount`);
};

export const getAllCountries = () => {
  return axios.get(`${link}/admin/product_management/getCountries`);
};
export const getAllStates = (id) => {
  return axios.get(`${link}/admin/product_management/getState/${id}`);
};
export const getAllCities = (id, sId) => {
  return axios.get(`${link}/admin/product_management/getCity/${sId}/${id}`);
};
export const getFeaturedJobs = () => {
  return axios.get(
    `https://acadshr.sulonya.com/admin/product_management/featureJob`
  );
};
export const getInstituteCount = () => {
  return axios.get(`${link}/candidate/clientsCount/100`);
};

export const searchInstituteJobs = (title) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "get",
    url: `${link}/ahr/job/search/${title}`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

// added by uzhairkhan
export const getAllInstituteJobsById = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "get",
    url: `${instituteLink}/ahr/job`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
// added by uzhairkhan
